<template>
  <div class="videoComponent">
    <button
      :id="fancyboxId"
      class="text-decoration-none fancy"
      data-fancybox
      data-width="800"
      data-height="450"
      :href="`#${internalVideoId}`"
    >
      <slot></slot>
    </button>
    <WrappedVideo :name="name" :id="internalVideoId" style="display: none;" />
  </div>
</template>

<script>
import { createRandomString } from "@/services/random";
import WrappedVideo from "./WrappedVideo";

export default {
  name: "videoComponent",
  components: {
    WrappedVideo
  },
  props: {
    name: String
  },
  data() {
    return {
      fancyboxId: createRandomString({ prefix: "fancybox" }),
      internalVideoId: createRandomString({ prefix: "video" }),
      videoVisible: false
    };
  },
  mounted: function() {
    window.jQuery("#" + this.fancyboxId).fancybox({
      arrows: false,
      infobar: false,
      toolbar: false,
      beforeShow: this.beforeFancyboxShow
    });
  },
  methods: {
    beforeFancyboxShow() {
      this.videoVisible = true;
    }
  }
};
</script>

<style scoped>
img {
  max-width: 80px;
  max-height: 80px;
  height: 10vw;
  width: 10vw;
}
button {
  display: flex;
  text-align: left;
}
p {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 1rem;
  min-width: 210px;
  max-width: 60vw;
}
.videoComponent {
  margin: auto;
  display: flex;
  width: auto;
}
</style>
